if (!customElements.get('price-sale-badge')) {
  customElements.define(
    'price-sale-badge',
    class priceSaleBadge extends HTMLElement {
      constructor() {
        super();

        const productElement = this.closest('.product');
        const cardElement = this.closest('.product-card-wrapper');

        if (productElement) {
          this._parentElement = productElement;
          this._parentType = 'product';
        } else if (cardElement) {
          this._parentElement = cardElement;
          this._parentType = 'card';
        } else {
          this._parentElement = null;
          this._parentType = 'none';
        }
      }

      connectedCallback() {
        if (this._parentType === 'product') {
          this.mediaElement = this._parentElement.querySelector('.product__media-wrapper .product__price-sale-badge--wrapper');
        } else if (this._parentType === 'card') {
          this.mediaElement = this._parentElement.querySelector('.card__media .card-product__price-sale-badge--wrapper');
        }

        if (this.mediaElement) {
          this.mediaElement.innerHTML = this.innerHTML;
          this.mediaElement.classList.remove('hidden');
        }
      }
    }
  )
}
